var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "18px",
    viewBox: "0 0 9 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94533 5.96416L0 5.96416L0 8.99472L1.94533 8.99472L1.94533 18L5.9414 18L5.9414 8.99496L8.6231 8.99496C8.6231 8.99496 8.87413 7.54179 8.99576 5.95303L5.95656 5.95303L5.95656 3.88112C5.95656 3.57131 6.39206 3.15484 6.82279 3.15484L9 3.15484L9 0L6.03966 0C1.84654 -0.000247201 1.94533 3.03316 1.94533 3.48615L1.94533 5.96416Z",
    id: "fb",
    fill: "#FFFFFF",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFacebook);
export default __webpack_public_path__ + "static/media/ico-facebook.5df8f55f7b7c14392db1d20e08d8a4f1.svg";
export { ForwardRef as ReactComponent };